class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/fetch`;
    }
    /**
     * Returns time-value data aggregations filtered by parameters specified
     * HTTP Method: post
     * Endpoint: /analytics/calls/v1/accounts/{accountId}/timeline/fetch
     * Rate Limit Group: Light
     * App Permission: Analytics
     */
    async post(timelineRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), timelineRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
